module.exports = __webpack_public_path__ + "img/aeroland-payment-box-icon-06.d6c8ff38.png";